import React from 'react';
import '../../styles/Aboutus/BenefitSection.css';

const BenefitSection = () => {
  return (
    <div className="benefit-section">
      <div className="frame-empty">
        <div className="our-benefits-frame">
          <div className="text-our-benefits">
            <div className="text-benefit-card-title">
              <h3 className="our-benefits">Our Benefits</h3>
            </div>
            <h1 className="by-joining-devsinc">
              By Joining DevSinc, One Can Avail a Lot Of Benefits.
            </h1>
          </div>
        </div>
        <div className="rectangle-section-img">
          <div className="install-our-top-rated">
            Install our top-rated dropshipping app to your e-commerce site and
            get access to US Suppliers, AliExpress vendors, and the best.
          </div>
        </div>
        <div className="frame-benefit-card">
          <div className="group-benefit-cards">
            <div className="benefit-card">
              <div className="rectangle-card-number">
                <div className="card-number">
                  <div className="text-semicolon" />
                  <div className="rectangle-standardization">
                    <div className="frame-benefit-card1">01</div>
                  </div>
                </div>
              </div>
              <div className="group-benefits">
                <h3 className="standardization">Standardization</h3>
              </div>
              <div className="when-working-in-container">
                <span>{`When working in a global workplace, it’s often difficult to gauge learners’ training experiences, which are critical to understand the problem at hand.`}</span>
              </div>
            </div>
            <div className="benefit-card1">
              <div className="benefit-card-container">
                <div className="card-number1">
                  <div className="card-number2" />
                  <div className="separator">
                    <div className="standardization-affordable-pri">02</div>
                  </div>
                </div>
              </div>
              <div className="weekend-u-x">
                <h3 className="reduced-costs">Reduced Costs</h3>
              </div>
              <div className="with-weekend-ux-container">
                <span>{`With Weekend UX, there’s no cost to reproduce materials and, thanks to mobile learning and microlearning.`}</span>
              </div>
            </div>
            <div className="benefit-card2">
              <div className="frame-benefit-card2">
                <div className="card-number3">
                  <div className="frame-frame-standardization" />
                  <div className="ellipse">
                    <div className="framework">03</div>
                  </div>
                </div>
              </div>
              <div className="more-customization">
                <h3 className="more-customization1">More Customization</h3>
              </div>
              <div className="ust-like-learners-container">
                <span>{`Just like learners aren’t one-size-fits-all, learning is not a one-size-fits-all experience. By using different tool, we cater to different audiences. `}</span>
              </div>
            </div>
          </div>
          <div className="group-benefit-cards1">
            <div className="benefit-card3">
              <div className="card-number-wrapper">
                <div className="card-number4">
                  <div className="card-number-child" />
                  <div className="wrapper">
                    <div className="div">04</div>
                  </div>
                </div>
              </div>
              <div className="affordable-pricing-wrapper">
                <h3 className="affordable-pricing">Affordable Pricing</h3>
              </div>
              <div className="with-weekend-ux-container1">
                <span>
                  {`With `}
                  <span className="weekend">Weekend</span>
                  {` UX, there’s no cost to reproduce materials. `}
                </span>
              </div>
            </div>
            <div className="benefit-card4">
              <div className="card-number-container">
                <div className="card-number5">
                  <div className="card-number-item" />
                  <div className="container">
                    <div className="div1">05</div>
                  </div>
                </div>
              </div>
              <div className="learner-satisfaction-wrapper">
                <h3 className="learner-satisfaction">Learner Satisfaction</h3>
              </div>
              <div className="if-you-really-container">
                <span>{`If you really want students to retain what they learn, you’ll need to aim for high satisfaction rates. This is ensured in our work.`}</span>
              </div>
            </div>
            <div className="benefit-card5">
              <div className="card-number-frame">
                <div className="card-number6">
                  <div className="card-number-inner" />
                  <div className="frame">
                    <div className="div2">06</div>
                  </div>
                </div>
              </div>
              <div className="multimedia-materials-wrapper">
                <h3 className="multimedia-materials">Multimedia Materials</h3>
              </div>
              <div className="one-of-the-container">
                <span>{`One of the main reasons why custom eLearning is effective is that it’s the perfect delivery method for students and has multimedia support. `}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitSection;
